<template>
    <div class="row  mb-3 mb-lg-5 ">
        <div class="col-12 col-lg-6  pb-lg-0 pb-4 ">
            <h1 class="first">{{listTitle}}</h1>
        </div>
        <div class="col-12 col-md-6 text-md-right text-center d-none d-lg-block">
            <a :href="backBtnLink"
               class="d-inline-block px-3 btn-orange">{{backBtnTitle}}</a>
        </div>
    </div>
</template>

<script>
  import * as AppConfig from '@/config/AppConfig'

  export default {
    name: 'SearchHeader',
    data () {
      return {
        listTitle: AppConfig.T_LIST_TITLE,
        backBtnTitle: AppConfig.T_BACK_BTN,
        backBtnLink: AppConfig.BACK_BTN_LINK
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SearchHeader.vue